import appCONST from './../../../constants/app.constants';

export const ENDPOINTS = {
    checkEligibilityUrl: '/atc/eligibility',
    priceMatrixUrl: '/atc/calendar',
    flightSearchUrl: '/atc/flightsearch',
    rebookUrl: '/atc/rebookandreprice',
    searchLocationUrl: '/staticdata/SearchAirportsAlternate',
    checkAgentApiKeyUrl: '/atc/checkagentapikey',
    cabinClassesUrl: '/atc/getcabinclasses',
};

export default function AtcApiFactory(
    $http,
    sessionService,
) {
    'ngInject';

    const checkElegibilityUrl = ENDPOINTS.checkEligibilityUrl;
    const priceMatrixUrl = ENDPOINTS.priceMatrixUrl;
    const searchFlightsUrl = ENDPOINTS.flightSearchUrl;
    const rebookUrl = ENDPOINTS.rebookUrl;
    const searchLocationUrl = ENDPOINTS.searchLocationUrl;
    const checkAgentApiKeyUrl = ENDPOINTS.checkAgentApiKeyUrl;
    const cabinClassesUrl = ENDPOINTS.cabinClassesUrl;

    const airlines = [];
    const filterUrl = searchFlightsUrl;

    return {
        checkEligibility,
        getCalendarPriceMatrix,
        searchFlights,
        getFlightsCabinClasses,
        getTimeSlots,
        getAirlines,
        moreFlightResults,
        rebook,
        filter,
        searchLocation,
        getRules,
        checkAgentApiKey,
    };

    function checkEligibility(request) {
        return $http.apiGET(checkElegibilityUrl, {params: request});
    }

    function getCalendarPriceMatrix(request) {
        return $http.apiPOST(priceMatrixUrl, request);
    }

    function searchFlights(request) {
        return $http.apiPOST(searchFlightsUrl, request);
    }

    function moreFlightResults(request) {
        return $http.apiPOST(searchFlightsUrl, request);
    }

    function rebook(request) {
        return $http.apiPOST(rebookUrl, request);
    }

    function filter(parameters) {
        return $http.apiPOST(filterUrl, parameters);
    }

    function getFlightsCabinClasses() {
        return $http.apiGET(cabinClassesUrl, {cache: true})
                .then(({data}) => data);
    }

    function getTimeSlots() {
        return [];
    }

    function getAirlines() {
        return airlines;
    }

    function searchLocation(request) {
        return $http.apiGET(searchLocationUrl, request)
            .then(({data}) => data);
    }

    function getRules(params) {
        const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');
        const anonymousLink = appCONST.serverUrl + '/api/flights/SearchRulesAnonymous';

        const requestData = {
            FlightRecommendationId: params.recommendationId,
            FareRecommendationId: params.fareId,
            FlightGroupIds: params.flightGroups,
            SearchId: params.searchId,
            Travelers: {
                Adult: params.adultCount,
                Infant: params.infantCount,
                Child: params.childCount,
            },
        };

        const requestConfig = {
            culture: params.culture,
        };

        return (isReadOnlyMode)
            ? $http.post(anonymousLink, requestData, requestConfig)
            : $http.apiPOST('/flights/SearchRules', requestData);
    }

    function checkAgentApiKey(request) {
        return $http.apiGET(checkAgentApiKeyUrl, {params: request});
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/services/atcApi.js